export interface dataType {
    contactId: number,
    isTester: boolean,
    environment: number | string,
}

export default function SearchContactId(data: dataType[], searchId: number) {

    const resultObject: dataType|undefined = data.find((item: dataType) => item.contactId === searchId);
    if (resultObject === undefined) {
        const newResult: dataType = {contactId: searchId, isTester: false, environment: 'default'}
        return newResult;
    }
    else if (typeof resultObject.environment === 'number' && ![501, 502, 541, 551].includes(resultObject.environment)) {
        resultObject.environment = 'default'
    }
    return resultObject;
}